<com-busy-inform-button
  *ngIf="hasIntersection$ | async"
  [events]="events"
  [forecastEventStart]="eventStart"
  [forecastEventEnd]="eventEnd"
  [busyInterval]="events | getBusyDateRange: eventStart : eventEnd"
  [height]="34"
></com-busy-inform-button>
